<template>
  <div class="schedule">
    <top :title="nav_title" :color="theme_color"></top>
    <van-search v-model="keywords" placeholder="请输入日程关键词" @search="onSearch" shape="round" background="#f7f7f7">
      <template #right-icon>
        <div @click="onSearch" class="search-icon">搜索</div>
      </template>
    </van-search>
    <div class="timeTabs-wrap2">
      <div class="timeTabs2">
        <div class="tab-item2" v-for="(item, index) in meetingDays" :key="getDayKey(item) || index"
          @click="switchDate(item)" :class="getDayKey(item) == active ? 'active' : ''" :style="{
            background: getDayKey(item) == active && theme_color ? theme_color : ''
          }">
          {{ item.name }}
          <!-- <p v-if="item.week" class="week">{{ item.week }}</p> -->
        </div>
      </div>
    </div>
    <div class="content">
      <van-skeleton title :row="5" :loading="sessionsLoading && !scheduleList.length">
        <ul class="leftC">
          <li class="item" v-for="(item, index) in scheduleList" :key="item.id || index"
            :style="{ background: theme_color ? theme_color : '' }" @click="hallSessionDetail(item)">
            <p v-html="formatTitle(
              item.daily_preview_title ? item.daily_preview_title : item.name
            )
              "></p>
            <p v-if="item.hall_name" v-html="formatTitle(item.hall_name ? item.hall_name : '')" style="font-size: 12px;">
            </p>
            <p class="lookAll">点击查看完整日程</p>
          </li>
        </ul>
        <div class="rightC">
          <div class="sessionList">
            <div class="list" v-for="(value, index) in scheduleList" :key="value.id || index"
              :class="meeting_id == 709 && index == 1 ? 'move' : ''">
              <div v-for="(val, ind) in (value.chapters || [])" :key="val.id || ind">
                <router-link v-if="val.is_show_live" class="item" :to="{
                  path: '/vascularNews/meeting/scheduleList',
                  query: {
                    meeting_id: meeting_id,
                    id: val.parallel_session_id || value.id,
                    chapter_id: val.id,
                    button_id: button_id || ''
                  }
                }" style="background:#ffffff">
                  <h1 :class="meeting_id == 473 ? 'sp_theme_color' : ''" :style="{
                    background: (val.id == 12273 || val.id == 12214) ? '#C33229' : val.id == 7937 ? theme_color : schedule_color ? schedule_color : '',
                    color: val.id == 7937 ? '#fff' : schedule_font_color ? schedule_font_color : ''
                  }">
                    {{ val.start_at }}-{{ val.end_at }}
                  </h1>
                  <div :style="{
                    background: val.id == 7937 ? theme_color : '#fff'
                  }">
                    <img :src="val.daily_preview_img" v-if="val.daily_preview_img" />
                    <p class="line-clamp-5" v-else v-html="formatTitle(val.name)" :style="{
                      color: val.id == 7937 ? '#fff' : ''
                    }"></p>
                  </div>
                </router-link>
              </div>

              <div style="width:10px"></div>
            </div>
          </div>
        </div>
      </van-skeleton>
    </div>
  </div>
</template>
<script>
import {
  ButtonDetail,
  NewMeetingDetail,
  NewMeetingDays,
  NewMeetingSessions
} from "../../../config/interface.js";
import Top from "../components/Top";
import { Skeleton } from "vant";

export default {
  components: {
    Top,
    Skeleton
  },
  data() {
    return {
      meeting_id: 0,
      button_id: this.$route.query.button_id
        ? this.$route.query.button_id
        : this.$route.query.b_id,
      active: "",
      meetingDays: [], // 新接口-日期列表
      scheduleList: [], // 当前日期会场列表
      sessionsLoading: false,
      img_src: "",
      theme_color: "#901D22", // 无定制色时的默认主题色
      schedule_color: "",
      schedule_font_color: "",
      keywords: "",
      showSeachResult: false,
      nav_title: "会议日程",
      color: "#FFFFFF",
      details: {}
    };
  },
  mounted() {
    this.meeting_id = this.$route.query.id || this.$route.query.meeting_id;
    // 有缓存的定制色则先用，减少二次进入时默认色→定制色闪烁
    this.applyCachedTheme();
    this.initPage();
  },
  methods: {
    applyCachedTheme() {
      if (!this.meeting_id) return;
      const cached = localStorage.getItem("meeting_theme_" + this.meeting_id);
      if (cached) {
        this.theme_color = cached;
      }
    },
    // 并行拉取会议信息 + 日期，再按日请求会场
    initPage() {
      Promise.all([this.getMeetingDetail(), this.getMeetingDays()]).then(() => {
        this.initActiveDate();
      });
    },
    // 新接口-会议详情（主题色 / 分享等）
    getMeetingDetail() {
      return fetch(NewMeetingDetail(this.meeting_id), {}, "GET").then(res => {
        if (res.code != 0) return;
        const data = res.data || {};
        this.details = data;
        this.img_src = data.schedule_center_img || "";
        if (data.name) document.title = data.name;
        // 有定制色用定制色，否则保持默认色
        const color = data.theme_color_hex || "#901D22";
        this.theme_color = color;
        localStorage.setItem("meeting_theme_" + this.meeting_id, color);
        this.schedule_color = data.schedule_color_hex || "";
        this.schedule_font_color = data.schedule_font_color_hex || "";
        if (this.button_id) {
          this.getButtonData();
        } else if (common.is_weixin()) {
          common.wxShare(data.name, data.title, data.shareimg);
        }
      });
    },
    // 新接口-会场日期列表
    getMeetingDays() {
      return fetch(NewMeetingDays(this.meeting_id), {}, "GET").then(res => {
        if (res.code == 0) {
          this.meetingDays = res.data || [];
        }
      });
    },
    getDayKey(day) {
      if (!day) return "";
      if (typeof day === "string") return day;
      return day.name || day.start_day || "";
    },
    findDayByKey(key) {
      if (!key || !this.meetingDays.length) return null;
      return (
        this.meetingDays.find(
          d => d.name === key || d.start_day === key || this.getDayKey(d) === key
        ) || null
      );
    },
    // 初始化选中日期：今天 → 记忆日期 → 第一天
    initActiveDate() {
      if (!this.meetingDays.length) return;
      const today = this.getToday();
      const saved = localStorage.getItem("schedule_date");
      const day =
        this.meetingDays.find(d => d.name === today) ||
        this.findDayByKey(saved) ||
        this.meetingDays[0];
      this.switchDate(day);
    },
    // 获取按钮信息
    getButtonData() {
      if (this.button_id) {
        const url = ButtonDetail;
        let params = {
          button_id: this.button_id
        };
        const method = "POST";
        fetch(url, params, method).then(res => {
          if (res.code == 0) {
            this.nav_title = res.data.name;
            if (common.is_weixin()) {
              let data = res.data;
              common.wxShare(
                data.share_title,
                this.details.name,
                data.share_img
              );
            }
          }
        });
      }
    },
    getToday() {
      let date = new Date();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return month + "月" + day + "日";
    },
    // 切换日期 → 请求当日会场列表
    switchDate(day) {
      const dayObj =
        typeof day === "string" ? this.findDayByKey(day) : day;
      if (!dayObj) return;
      const key = this.getDayKey(dayObj);
      this.active = key;
      localStorage.setItem("schedule_date", key);
      this.$nextTick(() => {
        this.fetchSessionsByDay(dayObj);
      });
    },
    // 新接口-按日会场列表（含章节预览）
    fetchSessionsByDay(day) {
      if (!this.meeting_id) return;
      this.sessionsLoading = true;
      const params = {
        start_day: day.start_day,
        end_day: day.end_day,
        type_name: "schedule"
      };
      fetch(NewMeetingSessions(this.meeting_id), params, "GET")
        .then(res => {
          this.sessionsLoading = false;
          if (res.code != 0) {
            this.scheduleList = [];
            return;
          }
          const data = res.data;
          let list = Array.isArray(data)
            ? data
            : (data && (data.list || data.sessions)) || [];
          this.scheduleList = list.map(item => this.normalizeSession(item));
        })
        .catch(() => {
          this.sessionsLoading = false;
          this.scheduleList = [];
        });
    },
    normalizeSession(item) {
      if (!item || typeof item !== "object") return item;
      const chapters = Array.isArray(item.chapters) ? item.chapters : [];
      return {
        ...item,
        show: false,
        chapters: chapters.map(ch => ({
          ...ch,
          start_at: this.handleDate(ch.start_at),
          end_at: this.handleDate(ch.end_at)
        }))
      };
    },
    // 处理日期  09:30样式
    handleDate(date) {
      if (!date) return "";
      const str = String(date);
      if (str.indexOf(" ") === -1) {
        const parts = str.split(":");
        if (parts.length >= 2) return parts[0] + ":" + parts[1];
        return str;
      }
      let time = str.split(" ")[1].split(":");
      return time[0] + ":" + time[1];
    },
    formatTitle(title) {
      if (!title) return "";
      let strs = String(title).split(" ");
      let str = "";
      for (let i = 0; i < strs.length; i++) {
        str = str + strs[i] + "<br/>";
      }
      return str;
    },
    onSearch() {
      if (this.keywords) {
        this.$router.push({
          path: "/vascularnews/schedule/result",
          query: {
            id: this.meeting_id,
            button_id: this.button_id,
            keywords: this.keywords
          }
        });
      }
    },
    hallSessionDetail(item) {
      this.$router.push({
        path: "/vascularnews/meeting/scheduleList",
        query: {
          meeting_id: this.meeting_id,
          id: item.id,
          button_id: this.button_id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.schedule {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .header-img {
    img {
      width: 100%;
      display: block;
    }

    // height: 70px;
  }

  .van-search /deep/.van-field__right-icon {
    color: #666666;
    background: #ebebeb;
    border-radius: 15px;
    margin-right: 5px;
    width: 60px;
    text-align: center;
  }

  .timeTabs2 {
    padding: 0px 12px 5px;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;

    .tab-item2 {
      display: inline-block;
      font-size: 14px;
      color: #666666;
      min-width: 90px;
      height: auto;
      text-align: center;
      line-height: 22px;
      border-radius: 5px;
      margin: 5px 15px 5px 0;
      background: #ffffff;
      cursor: pointer;
      padding: 7px 8px;
      box-sizing: border-box;

      .week {
        font-size: 11px;
        line-height: 16px;
        margin: 0;
        opacity: 0.85;
      }
    }

    .active {
      color: #fff;
      background: #901d22;
    }
  }

  .content {
    padding: 0px 0 10px 10px;
    // background-color: #f1f2f4;
    flex: 1;
    overflow: scroll;

    .leftC {
      float: left;
      width: 90px;

      .item {
        // display: -webkit-box;
        box-sizing: border-box;
        width: 90px;
        background: #901d22;
        color: white;
        border-radius: 3px;
        height: 120px;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 14px;
        // letter-spacing: 0.5px;
        margin-bottom: 10px;
        text-align: center;
        border-radius: 10px;
        padding: 0 10px;
        flex-direction: column;
        display: flex;

        img {
          height: 100%;
        }
      }
    }

    .rightC {
      overflow-x: auto;
      float: left;
      width: calc(100% - 90px);
      padding-left: 10px;

      .list {
        display: -webkit-box;
        // margin-left: 5px;
        // margin-right: 5px;
        // white-space: nowrap;
        // margin-bottom: 0.32rem;
      }

      .move {
        margin-left: 130px;
      }

      .item {
        display: block;
        box-sizing: border-box;
        background: #901d22;
        border-radius: 3px;
        width: 120px;
        height: 120px;
        margin-right: 10px;
        margin-bottom: 10px;
        text-align: center;
        border-radius: 10px;
        overflow: hidden;

        img {
          width: 100%;
        }

        h1 {
          font-weight: normal;
          text-align: center;
          font-size: 12px;
          line-height: 34px;
          color: #901d22;
          background: linear-gradient(90deg, #ffe6e7 0%, #fff1f1 100%);
          letter-spacing: 0.42px;
        }

        div {
          padding: 5px 10px;
          border-radius: 3px;
          background: #fff;
          height: 85px;
          display: flex;
          align-items: center;
          justify-content: center;

          p {
            word-break: break-all;
            font-size: 12px;
            color: black;
            letter-spacing: 0.42px;
            white-space: pre-wrap;
          }
        }
      }
    }
  }

  .content:after {
    display: block;
    content: "";
    clear: both;
  }
}

.van-search__content {
  background: white;
}

.sp_theme_color {
  background-color: #0a318e !important;
  color: #0a318e;
}

.lookAll {
  padding: 2px 4px;
  background: rgba($color: #fff, $alpha: 0.2);
  color: #fff;
  font-size: 8px;
  font-weight: 400;
  // line-height: 24px;
  white-space: nowrap;
  cursor: pointer;
  margin-top: 10px;
}
</style>
<style>
/* @media screen and (min-width:580px) {
  #app {
    max-width: 90% !important;
  }
} */

@media screen and (min-width:1000px) {
  .schedule .content .rightC .item {
    width: 160px !important;
  }

  .schedule .content .rightC .move {
    margin-left: 170px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Schedule.vue